import AnimatedDotBubbleIcon from '@/components/Icons/AnimatedDotBubbleIcon'
import AnimatedHomeIcon from '@/components/Icons/AnimatedHomeIcon'
import AnimatedMagnifierIcon from '@/components/Icons/AnimatedMagnifierIcon'
import AnimatedPersonalIcon from '@/components/Icons/AnimatedPersonalIcon'
import AnimatedThreeDotsIcon from '@/components/Icons/AnimatedThreeDotsIcon'
import { FunctionComponent, SVGProps } from 'react'
import z from 'zod'

export enum Tab {
	FOLLOWING_POST = 'FOLLOWING_POST',
	NOTIFICATION = 'NOTIFICATION',
	EXPLORE_POST = 'EXPLORE_POST',
	USER_PROFILE = 'USER_PROFILE',
	MORE = 'MORE',
}

export const SIDEBAR_WIDTH = 84

export const SidebarTabIconEnumSchema = z.enum([
	'HOME',
	'MAGNIFIER',
	'DOT_BUBBLE',
	'PERSONAL',
	'THREE_DOTS',
])
export type SidebarTabIconEnum = z.infer<typeof SidebarTabIconEnumSchema>

export const SIDEBAR_TAB_ICON_MAP: Record<
	SidebarTabIconEnum,
	FunctionComponent<SVGProps<SVGSVGElement> & { isActive?: boolean }>
> = {
	[SidebarTabIconEnumSchema.enum.HOME]: AnimatedHomeIcon,
	[SidebarTabIconEnumSchema.enum.MAGNIFIER]: AnimatedMagnifierIcon,
	[SidebarTabIconEnumSchema.enum.DOT_BUBBLE]: AnimatedDotBubbleIcon,
	[SidebarTabIconEnumSchema.enum.PERSONAL]: AnimatedPersonalIcon,
	[SidebarTabIconEnumSchema.enum.THREE_DOTS]: AnimatedThreeDotsIcon,
}
